import React, { useEffect } from 'react';
import LandingNavbar from '../components/Landing/LandingNavbar';
import LandingFooter from '../components/Landing/LandingFooter';
import './landing.css';
import caseStudiesImg from '../assets/case_studies.png';

const CaseStudiesPage: React.FC = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.case-study-card').forEach(el => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="main-landing-admin">
            <LandingNavbar />

            <section className="hero-sub">
                <div className="container hero-sub-container">
                    <div className="hero-sub-content">
                        <h1 className="section-title gradient-text" style={{ textAlign: 'left', marginBottom: '1.5rem' }}>Success <span>Stories</span></h1>
                        <p className="hero-description" style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1.25rem', lineHeight: '1.6' }}>
                            Real-world implementations that transformed businesses with Asknow AI.
                        </p>
                        <div style={{ marginTop: '2rem' }}>
                            <div className="tech-badge" style={{ display: 'inline-block', marginRight: '1rem', marginBottom: '1rem' }}>Global Impact</div>
                            <div className="tech-badge" style={{ display: 'inline-block', marginRight: '1rem', marginBottom: '1rem' }}>Proven ROI</div>
                        </div>
                    </div>

                    <div className="featured-image-container">
                        <img src={caseStudiesImg} alt="Case Studies" className="featured-image" />
                    </div>
                </div>
            </section>

            <section style={{ padding: '6rem 0' }}>
                <div className="container">
                    <h2 className="section-title">Client <span>Results</span></h2>
                    <div className="case-studies-grid">
                        <div className="case-study-card">
                            <div className="case-study-image">
                                <div className="case-study-icon">
                                    <i className="fas fa-chart-bar"></i>
                                </div>
                            </div>
                            <div className="case-study-content">
                                <h3>E-commerce Optimization</h3>
                                <p className="case-study-industry">Retail & E-commerce</p>
                                <p className="case-study-description">
                                    Implemented AI-powered recommendation engine that increased conversion rates by 35% and average order value by 28%.
                                </p>
                                <div className="case-study-results">
                                    <div className="result-item">
                                        <span className="result-number">35%</span>
                                        <span className="result-label">Conversion Increase</span>
                                    </div>
                                    <div className="result-item">
                                        <span className="result-number">28%</span>
                                        <span className="result-label">Order Value Growth</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="case-study-card">
                            <div className="case-study-image">
                                <div className="case-study-icon">
                                    <i className="fas fa-industry"></i>
                                </div>
                            </div>
                            <div className="case-study-content">
                                <h3>Manufacturing Intelligence</h3>
                                <p className="case-study-industry">Manufacturing</p>
                                <p className="case-study-description">
                                    Deployed predictive maintenance system that reduced equipment downtime by 60% and maintenance costs by 45%.
                                </p>
                                <div className="case-study-results">
                                    <div className="result-item">
                                        <span className="result-number">60%</span>
                                        <span className="result-label">Downtime Reduction</span>
                                    </div>
                                    <div className="result-item">
                                        <span className="result-number">45%</span>
                                        <span className="result-label">Cost Savings</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="case-study-card">
                            <div className="case-study-image">
                                <div className="case-study-icon">
                                    <i className="fas fa-heartbeat"></i>
                                </div>
                            </div>
                            <div className="case-study-content">
                                <h3>Healthcare Analytics</h3>
                                <p className="case-study-industry">Healthcare</p>
                                <p className="case-study-description">
                                    Created patient risk assessment model that improved early detection accuracy by 50% and reduced readmission rates by 30%.
                                </p>
                                <div className="case-study-results">
                                    <div className="result-item">
                                        <span className="result-number">50%</span>
                                        <span className="result-label">Detection Accuracy</span>
                                    </div>
                                    <div className="result-item">
                                        <span className="result-number">30%</span>
                                        <span className="result-label">Readmission Reduction</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="case-study-card">
                            <div className="case-study-image">
                                <div className="case-study-icon">
                                    <i className="fas fa-university"></i>
                                </div>
                            </div>
                            <div className="case-study-content">
                                <h3>FinTech Fraud Detection</h3>
                                <p className="case-study-industry">Finance</p>
                                <p className="case-study-description">
                                    Our advanced anomaly detection models reduced fraudulent transactions by 75% while decreasing false positives by 40%.
                                </p>
                                <div className="case-study-results">
                                    <div className="result-item">
                                        <span className="result-number">75%</span>
                                        <span className="result-label">Fraud Reduction</span>
                                    </div>
                                    <div className="result-item">
                                        <span className="result-number">40%</span>
                                        <span className="result-label">False Positive Decrease</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <LandingFooter />
        </div>
    );
};

export default CaseStudiesPage;
